const TEAM_PHOTOS_URL = "https://static.vivamoselcampo.co/uploads/assets/faces";

const teamMembers = [
  {
    name: "Douglas Velásquez",
    role: "Líder de proyecto",
    photo: `${TEAM_PHOTOS_URL}/douglas-velasquez.jpg`
  },
  {
    name: "Daniel Cardozo",
    role: "Ingeniero de Software",
    photo: `${TEAM_PHOTOS_URL}/daniel-cardozo.jpg`
  },
  {
    name: "Elena Liberato",
    role: "Coordinadora Administrativa",
    photo: `${TEAM_PHOTOS_URL}/elena-liberato.jpg`
  },
  {
    name: "Javier Velásquez",
    role: "Asesor de Arquitectura",
    photo: `${TEAM_PHOTOS_URL}/javier-velasquez.jpg`
  }
];

export default teamMembers;



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/assets/teamMembers.js